export default "/images/a7f1b91c8edd4e4c91f83c800d7030e5.avif";